import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  UserIcon,
  BuildingOfficeIcon,
  EnvelopeIcon,
  PhoneIcon,
  MapIcon,
  PhotoIcon,
} from "@heroicons/react/24/outline";
import api from "../../api";

function AddJeweller() {
  const [form, setForm] = useState({
    name: "",
    business_name: "",
    email: "",
    mobile: "",
    address: "",
    latitude: "",
    longitude: "",
  });
  const [logo, setLogo] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.keys(form).forEach((key) => data.append(key, form[key]));
    if (logo) data.append("logo", logo);

    try {
      const res = await api.post("/jewellers", data);
      alert(
        `Jeweller registered!\nUsername: ${res.data.credentials.email}\nPassword: ${res.data.credentials.password}`
      );
      navigate("/jewellers");
    } catch (err) {
      console.error(err.response || err.message);
      alert("Error adding jeweller");
    }
  };

  return (
    <div className="bg-gray-50 flex justify-center p-6">
      <div className="w-full bg-white rounded-2xl shadow-lg p-8">
        {/* Header */}
        <div className="flex items-center mb-6 gap-2">
          <BuildingOfficeIcon className="h-6 w-6 text-purple-600" />
          <h1 className="text-2xl font-bold text-gray-800">
            Register New Jeweller
          </h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Row 1: Name & Business Name */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="relative">
              <label className="absolute -top-2 left-3 bg-white px-1 text-gray-500 text-sm flex items-center gap-1">
                <UserIcon className="h-4 w-4 text-purple-500" /> Name
              </label>
              <input
                type="text"
                name="name"
                placeholder="Enter name"
                value={form.name}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-1 focus:ring-purple-500 focus:border-purple-500 placeholder-gray-400"
                required
              />
            </div>

            <div className="relative">
              <label className="absolute -top-2 left-3 bg-white px-1 text-gray-500 text-sm flex items-center gap-1">
                <BuildingOfficeIcon className="h-4 w-4 text-purple-500" /> Business Name
              </label>
              <input
                type="text"
                name="business_name"
                placeholder="Enter business name"
                value={form.business_name}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-1 focus:ring-purple-500 focus:border-purple-500 placeholder-gray-400"
                required
              />
            </div>
          </div>

          {/* Row 2: Email & Mobile */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="relative">
              <label className="absolute -top-2 left-3 bg-white px-1 text-gray-500 text-sm flex items-center gap-1">
                <EnvelopeIcon className="h-4 w-4 text-purple-500" /> Email
              </label>
              <input
                type="email"
                name="email"
                placeholder="Enter email"
                value={form.email}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-1 focus:ring-purple-500 focus:border-purple-500 placeholder-gray-400"
                required
              />
            </div>

            <div className="relative">
              <label className="absolute -top-2 left-3 bg-white px-1 text-gray-500 text-sm flex items-center gap-1">
                <PhoneIcon className="h-4 w-4 text-purple-500" /> Mobile
              </label>
              <input
                type="text"
                name="mobile"
                placeholder="Enter mobile number"
                value={form.mobile}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-1 focus:ring-purple-500 focus:border-purple-500 placeholder-gray-400"
                required
              />
            </div>
          </div>

          {/* Address */}
          <div className="relative">
            <label className="absolute -top-2 left-3 bg-white px-1 text-gray-500 text-sm flex items-center gap-1">
              <MapIcon className="h-4 w-4 text-purple-500" /> Address
            </label>
            <textarea
              name="address"
              placeholder="Enter address"
              value={form.address}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-1 focus:ring-purple-500 focus:border-purple-500 placeholder-gray-400 resize-none"
            />
          </div>

          {/* Row 3: Latitude & Longitude */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="relative">
              <label className="absolute -top-2 left-3 bg-white px-1 text-gray-500 text-sm">
                Latitude
              </label>
              <input
                type="number"
                step="0.0000001"
                name="latitude"
                placeholder="Enter latitude"
                value={form.latitude}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-1 focus:ring-purple-500 focus:border-purple-500 placeholder-gray-400"
              />
            </div>
            <div className="relative">
              <label className="absolute -top-2 left-3 bg-white px-1 text-gray-500 text-sm">
                Longitude
              </label>
              <input
                type="number"
                step="0.0000001"
                name="longitude"
                placeholder="Enter longitude"
                value={form.longitude}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-1 focus:ring-purple-500 focus:border-purple-500 placeholder-gray-400"
              />
            </div>
          </div>

          {/* Logo */}
          <div className="relative">
            <label className="flex items-center gap-1 text-gray-500 text-sm mb-1">
              <PhotoIcon className="h-4 w-4 text-purple-500" /> Logo
            </label>
            <input
              type="file"
              onChange={(e) => setLogo(e.target.files[0])}
              className="w-full text-gray-600"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 rounded-xl shadow-md transition-all duration-200"
          >
            Register Jeweller
          </button>
        </form>
      </div>
    </div>
  );
}

export default AddJeweller;
